<template>
  <div>
    <a>Написать администратору в whatsapp</a>
    <a @click="$emit('onBuyPacket', 'workoff_order')">Оставить заявку на отработку пропущенного урока</a>
    <a @click="$emit('onBuyPacket', 'freeze_order')">Оставить заявку на временную заморозку абонемента</a>
  </div>
</template>

<script>
export default {
  name: "help",
  data() {
    return {}
  },
  props: {
    items: ''
  },
  methods: {}
}
</script>